import store from '@/store'
import cookie from 'js-cookie'
export function convertToTree(data) {
    const map = {}
    const tree = []
    const flatItems = []

    data.forEach(item => {
        map[item.id] = { ...item, children: [] }
    })

    data.forEach(item => {
        const menuItem = map[item.id]
        const isTreeItem = data.some(otherItem => otherItem.id === item.parent_id)
        if (isTreeItem) {
            const parentMenu = map[item.parent_id]
            if (parentMenu) {
                parentMenu.children.push(menuItem)
            }
        } else {
            flatItems.push(menuItem)
        }
    })

    return [...tree, ...flatItems]
}

// 生成单号
export function generateOrderNumber(type) {
    // 获取当前日期
    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = String(currentDate.getMonth() + 1).padStart(2, '0') // 月份从0开始，需要加1，然后补齐两位数
    const day = String(currentDate.getDate()).padStart(2, '0') // 补齐两位数

    // 生成序号，假设从1开始递增
    let serialNumber = 1 // 序号从1开始
    // 获取存储在本地的序号
    const storedSerialNumber = localStorage.getItem('orderSerialNumber')
    if (storedSerialNumber) {
        serialNumber = parseInt(storedSerialNumber) + 1 // 使用存储的序号并加1
    }
    // 将新的序号存储到本地
    localStorage.setItem('orderSerialNumber', serialNumber)

    // 生成订单号
    const orderNumber = `${type}${year}${month}${day}N${String(serialNumber).padStart(3, '0')}`

    return orderNumber
}

// trycatch封装
export async function handleRequest(requestFunction) {
    try {
        return await requestFunction()
    } catch (error) {
        // console.error(`错误提示, ${error}`)
    }
}

export function toChineseUpperCase(num) {
    const fraction = ['角', '分']
    const digit = [
        '零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'
    ]
    const unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ]
    const head = num < 0 ? '欠' : ''
    num = Math.abs(num)

    let s = ''
    for (let i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(num * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
    }
    s = s || '整'
    num = Math.floor(num)

    for (let i = 0; i < unit[0].length && num > 0; i++) {
        let p = ''
        for (let j = 0; j < unit[1].length && num > 0; j++) {
            p = digit[num % 10] + unit[1][j] + p
            num = Math.floor(num / 10)
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
    }
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
}

/**
 * 增加字符串中 'N' 后面的数字值
 *
 * 此函数处理特定格式的字符串，该字符串包含类型前缀和 'N' 后跟数字
 * 函数将 'N' 后面的数字提取出来，进行加1操作，然后将结果重新组合到字符串中
 * 如果字符串不符合预期格式，调用 `generateNumber` 生成新的编号
 *
 * @param {string} type - 类型前缀，例如 'ZH'
 * @param {string} str - 需要处理的字符串，格式为 'ZH20241110N001'
 * @returns {string} - 处理后的字符串，其中 'N' 后面的数字增加了1；如果输入不符合格式，返回新生成的编号
 */
export function incrementNValue(type, str) {
    if (!type) return

    // 匹配 'N' 后面的数字
    const match = str.match(/N(\d+)/)

    if (match) {
        // 提取并增加数字部分
        const numberPart = parseInt(match[1], 10)
        const incrementedNumber = numberPart + 1
        // 替换原字符串中的数字部分
        return str.replace(/N\d+/, `N${incrementedNumber.toString().padStart(3, '0')}`)
    } else {
        // 生成新的编号
        return generateNumber(type)
    }
}

/**
 * 生成新的编号
 *
 * 根据当前日期和指定的类型前缀生成一个新的编号
 * 编号格式为：类型前缀 + 年份 + 月份 + 日 + 'N' + 三位数的序号
 *
 * @param {string} type - 类型前缀，例如 'ZH'
 * @returns {string} - 新生成的编号，格式为 'ZH20241110N001'
 */
function generateNumber(type) {
    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = String(currentDate.getMonth() + 1).padStart(2, '0')
    const day = String(currentDate.getDate()).padStart(2, '0')
    const serialNumber = 1

    // 生成订单号
    return `${type}${year}${month}${day}N${String(serialNumber).padStart(3, '0')}`
}

// 判断产看数据权限（全部或自己）

export function checkDataPermission() {
    const seeAll = store.state.setSeeAll
    const userId = cookie.get('id')
    return seeAll === 1 && userId ? userId : ''
}

function getLocalDate() {
    const date = new Date()
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

export function getInitialDateRange() {
    // 获取当前日期
    const currentDay = new Date()

    // 获取上个月的第一天
    const firstDayOfLastMonth = new Date(
        currentDay.getFullYear(),
        currentDay.getMonth() - 1,
        2
    )
    return {
        start: firstDayOfLastMonth.toISOString().split('T')[0],
        end1: getLocalDate(),
        end: ''
    }
}
